import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'

import Socio from '@/components/Socio'
import SocioEdit from '@/components/Socio-edit'
import SocioPagamento from '@/components/Socio-pagamento'
import SocioNoregister from '@/components/Socio-noregister'

Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/diventasocio/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/', name: 'root', meta: { requiresEvent: false, requiresAuth: false }, components:{main: SocioEdit  }},
    
    { path: '/socio', name: 'socio', meta: { requiresAuth: false }, components: { main: Socio } }, 
    { path: '/socio-edit', name: 'socio.edit', meta: { requiresAuth: false }, components: { main: SocioEdit } }, 
    { path: '/socio-pagamento', name: 'socio.pagamento', meta: { requiresAuth: false }, components: { main: SocioPagamento } }, 
    { path: '/socio-noregister', name: 'socio.noregister', meta: { requiresAuth: false }, components: { main: SocioNoregister } }, 
    { path: '*', redirect: '/socio-edit' } 
  ]


})



router.beforeEach(async (to, from, next) => {
  console.log("beforeEach")
  let error = false

 
  teras.app.drawer = false
  //to.query contiene le variabili passate in modo standard es. ?variabile=valore
  //to.params contiene le variabili passate in vuejs passate in base a routes[]
  console.log("\nbeforeEach \ncheckFirst: "+router.checkFirst+"\nfrom: "+from.path+"\nto: "+to.path+"\n\n")
  teras.router.from = from.path
  teras.router.to = to.path
 /* */
  if (!teras.check.first){
    console.log("SONO RICHIESTE LE OPERAZIONI DI PRIMO AVVIO")
    await checkFirst(to)
  }
 
  console.log("AUTH FROM ROUTER "+teras.check.auth)
  if (!error && to.matched.some(record => record.meta.requiresAuth) && !teras.check.auth){
    console.log("È RICHIESTO UTENTE E NON È ANCORA VERIFICATO")
    teras.event.emit('checkAuth', from, to)
    error = true
  }
  if(error){
      console.log("beforeEach next is false")
      next(false)
  }else{
      console.log("beforeEach next")
      teras.app.ready = true
      next()
      teras.event.emit('routerChange', to)
  }

})

export default router
